import React from "react";
import { Box } from "@mui/material";
import { SwitchOffIcon, SwitchOnIcon } from "./widgetPreviewIcons";

function SettingsToggle({ checked, onChange, ariaLabel, disabled = false }) {
  return (
    <Box
      component="button"
      type="button"
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => {
        if (!disabled) onChange(!checked);
      }}
      sx={{
        p: 0,
        border: "none",
        background: "none",
        cursor: disabled ? "not-allowed" : "pointer",
        display: "flex",
        alignItems: "center",
        flexShrink: 0,
        opacity: disabled ? 0.6 : 1,
      }}
    >
      {checked ? <SwitchOnIcon /> : <SwitchOffIcon />}
    </Box>
  );
}

export default SettingsToggle;
